<template>
  <div class="d-flex-100 variationsBlock sizeDropBlock pos-rel">
    <span class="db-100 attr-title" v-html="`${variationGroup.variationGroupName}:`"></span>
    <button class="selectDropSize" v-on:click="visible = !visible">{{ getSelectedText || t('selection') }}
      <i class="lni lni-chevron-down"></i>
    </button>
    <div v-show="visible" class="toggleAttrsBlk">
      <ul>
        <li v-for="variationEntry in getVariationEntriesOfThisGroupFromVariationGroupData"
            :key="variationEntry.variationId"
            v-on:click="navigateToProduct(variationEntry.variationId)"
            :class="getVariationTextClass(defaultValue, variationEntry)">
          {{ variationEntry.variationName }}
          <span v-if="getVariationOutOfStock(variationEntry)" class="variation-not-available">
            ( {{ t('product_status.unavailable.text') }} )
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import variationSelectorMixin from './VariationSelectorMixin'

export default {
  name: 'VariationTextSelector',
  mixins: [variationSelectorMixin],
  data () {
    return {
      version: '0.0.2',
      visible: false
    }
  },
  created () {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.visible = false
      }
    })
  },
  methods: {
    getVariationOutOfStock (variation) {
      return variation.stock <= 0
    },
    getVariationTextClass (defaultValue, variation) {
      if (defaultValue === variation.variationName) {
        return 'selected'
      } else if (this.getVariationOutOfStock(variation)) {
        return 'disabled'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.selected {
  font-weight: bold
}
li {
  cursor: pointer
}
.attr-title {
  font-weight: 800;
}
.selectDropSize {
  padding: 5px 15px;
  background: #fff;
  border: 1px solid #707070;
  width: 100%;
  max-width: 50%;
  position: relative;
  color: black;
  @media screen and (max-width:575px) {
    max-width: 100%;
  }
}
.toggleAttrsBlk{
  position: absolute;
  top: 100%;
  border: 1px solid #ccc;
  z-index: 100;
  width: 100%;
  max-width: 50%;
  padding: 0;
  background: #fff;
  max-height: 310px;
  overflow-y: auto;
  @media screen and (max-width:575px) {
    max-width: 100%;
  }
  ul {
    margin: 0;
    list-style: none;
    padding: 0;
  }
  li {
    width: 100%;
    padding: 3px 15px;
    border-bottom: 1px solid #eaeaea;
    font-size: 14px;
    -webkit-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
    &:hover {
      background: #eaeaea;
    }
  }
}
i {
  right: 15px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>
